import React, { useEffect, useState } from "react";
import BackgroundImageFromUrl from "../../parseImage/BackgroundImageFromUrl";

const PrimaryButtonQuestion = ({
  style,
  disabled,
  isClick,
  prefix,
  suffix,
  onClick,
  children,
}) => {
  var buttonStyle = {
    width: "12.5rem",
    height: "3rem",
    border: "none",
    fontSize: "1.125rem",
    borderRadius: "1.5rem",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    boxShadow: "none",
    // color: disabled ? "#8C9DC1" : "#FAFBFC",
  };
  var prefixStyle = {
    position: "absolute",
    width: "1.125rem",
    height: "1.125rem",
    zIndex: "100",
    top: "0.875rem",
    left: "2.0625rem",
    // backgroundColor: disabled ? "#8C9DC1" : "#FAFBFC",
  };
  var suffixStyle = {
    position: "absolute",
    width: "1.125rem",
    height: "1.125rem",
    zIndex: "100",
    top: "0.875rem",
    right: "2.0625rem",
    // backgroundColor: disabled ? "#8C9DC1" : "#FAFBFC",
  };
  const [defaultState, setDefaultState] = useState(disabled ? false : true);
  const [hoveredState, setHoveredState] = useState(false);
  const [clickedState, setClickedState] = useState(isClick ? isClick : false);
  // const audio = new Audio("/sounds/click.mp3");
  var objectId = "";
  if (defaultState) {
    objectId =
      "admin/frontend-images/button/primary-button-question-default-bg-default.svg";
  }
  if (hoveredState) {
    objectId =
      "admin/frontend-images/button/primary-button-question-default-bg-hovered.svg";
  }

  const handleMouseEnter = () => {
    if (!clickedState && !disabled) {
      setDefaultState(false);
      setHoveredState(true);
    }
  };
  const handleMouseLeave = () => {
    if (!clickedState && !disabled) {
      setDefaultState(true);
      setHoveredState(false);
    }
  };
  const handleClick = () => {
    if (!disabled) {
      // audio.play();
      if (onClick) {
        onClick();
      }
      setClickedState(!clickedState);
      setHoveredState(false);
      setDefaultState(clickedState);
    }
  };
  const handleBlur = () => {
    if (disabled === false || disabled === undefined) {
      setClickedState(false);
      setDefaultState(true);
    }
  };
  useEffect(() => {
    if (disabled === false || disabled === undefined) {
      setDefaultState(true);
    } else {
      setDefaultState(false);
      setClickedState(false);
    }
  }, [disabled]);
  return (
    <div
      className="main is-relative"
      onBlur={handleBlur}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{
        ...style,
        maxWidth: `${style?.maxWidth ? `${style?.maxWidth}` : "12.5rem"}`,
      }}
    >
      {prefix && (
        <BackgroundImageFromUrl
          objectId={prefix}
          style={prefixStyle}
        ></BackgroundImageFromUrl>
      )}
      <BackgroundImageFromUrl
        objectId={objectId}
        className={`${
          defaultState
            ? "is-primary-button-default-color"
            : hoveredState
            ? "is-primary-button-hovered-color"
            : clickedState
            ? "is-kurio-main-color-black"
            : disabled
            ? "is-kurio-gray-light-2"
            : ""
        }  button  main-color has-text-weight-bold is-uppercase has-text-centered ${
          disabled
            ? "has-text-kurio-gray-main-accent"
            : "has-text-kurio-main-color-white"
        }`}
        style={buttonStyle}
        onClick={handleClick}
        type="button"
      >
        {children}
      </BackgroundImageFromUrl>
      {suffix && (
        <BackgroundImageFromUrl
          objectId={suffix}
          style={suffixStyle}
        ></BackgroundImageFromUrl>
      )}
    </div>
  );
};

export default PrimaryButtonQuestion;
